import React from 'react';

function Insatgram() {
  return (
    <section className="tc-instagram-style4">
      <div className="container">
        <div className="title mb-120">
          <h2 className="sec-title mb-30 js-splittext-lines"> instagram </h2>
          <p className="fsz-18 color-666 js-splittext-lines">
            Place that i share the look about the life, inspiration and latest
            projects
          </p>
        </div>
        <div className="imgs">
          <div className="row gx-2">
            <div className="col-lg-3">
              <a
                href="#"
                className="img d-block th-300 mt-3 mt-lg-0 wow zoomIn slow"
                data-wow-delay="0.2s"
              >
                <img
                  src="/home4_personal_architect/assets/img/instagram/insta1.jpg"
                  alt=""
                  className="img-cover"
                />
                <span className="icon">
                  <i className="lab la-instagram"></i>
                </span>
              </a>
            </div>
            <div className="col-lg-3">
              <a
                href="#"
                className="img d-block th-300 mt-3 mt-lg-0 wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <img
                  src="/home4_personal_architect/assets/img/instagram/insta2.jpg"
                  alt=""
                  className="img-cover"
                />
                <span className="icon">
                  <i className="lab la-instagram"></i>
                </span>
              </a>
            </div>
            <div className="col-lg-3">
              <a
                href="#"
                className="img d-block th-300 mt-3 mt-lg-0 wow zoomIn slow"
                data-wow-delay="0.6s"
              >
                <img
                  src="/home4_personal_architect/assets/img/instagram/insta3.jpg"
                  alt=""
                  className="img-cover"
                />
                <span className="icon">
                  <i className="lab la-instagram"></i>
                </span>
              </a>
            </div>
            <div className="col-lg-3">
              <a
                href="#"
                className="img d-block th-300 mt-3 mt-lg-0 wow zoomIn slow"
                data-wow-delay="0.8s"
              >
                <img
                  src="/home4_personal_architect/assets/img/instagram/insta4.jpg"
                  alt=""
                  className="img-cover"
                />
                <span className="icon">
                  <i className="lab la-instagram"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Insatgram;
